<script setup>
import { SOCIAL_SHARE_IMAGE, usePageHead } from '@composables/use-page-head'
import { computed } from 'vue'
import Layout from '@layouts/main-layout'
import ExploreGenres from '@components/explore/explore-genres'
import ExploreCharts from '@components/explore/explore-charts'
import ExplorePlaylists from '@components/explore/explore-playlists'

// `<component :is>` resolves a STRING against registered components, never against
// <script setup> bindings — the routes hand this view the panel name, so map it here.
const MAIN_COMPONENTS = { ExploreGenres, ExploreCharts, ExplorePlaylists }

const TABS = [
    { to: { name: 'browse/genres' }, label: 'Genres' },
    { to: { name: 'browse/charts/index' }, label: 'Charts' },
    { to: { name: 'browse/playlists/index' }, label: 'Playlists' },
]

// The hub renders at the browse URLs, so each tab keeps the head production already has
// indexed — byte-for-byte. The canonical falls back to the route path, i.e. the browse URL.
const PAGE_HEADS = {
    ExploreGenres: { title: 'Browse Genres', description: 'Browse FRISKY by genre — house, techno, progressive, deep, and more.' },
    ExploreCharts: { title: 'Charts', description: 'Top-curated charts of underground electronic mixes on FRISKY.' },
    ExplorePlaylists: { title: 'Playlists', description: 'Curated playlists across house, techno, progressive, and more on FRISKY.' },
}

const props = defineProps({
    mainComponent: {
        type: String,
        default: 'ExploreGenres',
    },
})

const mainView = computed(() => MAIN_COMPONENTS[props.mainComponent])

// usePageHead reads its source through toValue, so a getter keeps the title on the tab.
usePageHead(() => ({ ...PAGE_HEADS[props.mainComponent], image: SOCIAL_SHARE_IMAGE }))
</script>

<template>
    <Layout>
        <BaseContent title="Explore">
            <BaseTabPanel
                :tabs="TABS"
                is-underlined
                is-unpadded
                address-navigation
            />
            <component
                :is="mainView"
                class="panel"
            />
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.panel {
    padding-top: $space-32;
}
</style>
